<template>
  <div class="home"  v-loading="loading">

    <div class="header-box">
      <layoutHeader default-bg="rgba(0,0,0,0.4)"/>
    </div>
    <div class="content">
      <div class="banner">
        <div class="swiper-container swiper" id="homeSwiper" >
          <div class="swiper-wrapper">
            <template v-for="(item, index) in bannerList">
              <div class="swiper-slide" :key="index">
                <a :href="item.bannerLink">
                  <el-image :src="item.bannerUrl" style="width: 100vw; height: 56.25vw"></el-image>
                </a>
              </div>
            </template>
          </div>
          <div class="swiper-pagination"></div>

        </div>
      </div>
      <div class="article">
        <div class="main-container">

        <template v-for="(item, index) in planList">

          <router-link :to="item.path" :key="index">

          <div class="item">
            <div class="cover">
              <el-image :src="item.imageUrl"></el-image>
            </div>
            <div class="detail">
              <div class="title">{{item.title}}</div>
              <div class="desc" v-html="item.content"></div>
            </div>
          </div>
          </router-link>
        </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import layoutHeader from '@/components/layout/header'
import Model from '@/model/index'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

export default {
  components: {
    layoutHeader,
  },
  name: 'layout',
  data() {
    return {
      loading: true,
      bannerList: [],
      planList: [],
      autoplay: false
    }
  },
  async created() {
    await this.getBanner()
    await this.getScheme()
  },
  mounted() {
    this.loading = false
  },
  methods: {
    async getBanner() {
      const res = await Model.getBanner()
      if (res.code === 1) {
        this.bannerList = res.data.bannerRespList
        this.autoplay = res.data.bannerSlideshow === 1 ? res.data.bannerTime*1000 : 0
        console.log(this.autoplay)
        this.initSwiper()
      }
    },

    async getScheme() {
      const res = await Model.getScheme()
      if (res.code === 1) {
        this.planList = res.data
      }
    },
    initSwiper() {
      let autoplay = false
      if (this.autoplay > 0) {
        autoplay= {
          disableOnInteraction:false,
          delay: this.autoplay>0?this.autoplay:false,
        }
      }
      setTimeout(()=> {
        new Swiper('#homeSwiper', {
          spaceBetween: 30,
          loop: true,
          initialSlide: 0,
          autoplay,
          observeParents: true,   //修改swiper自己或子元素时，自动初始化swiper
          observer: true,
          pagination: '.swiper-pagination',
        })
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  background: #141414;

  .header-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .banner {
    width: 100%;
    text-align: center;
    height: 56.25vw;
  }

  .article {
    color: #fff;
    padding: 0 40px;

    .item {
      display: flex;
     margin: 80px 0;
    }

    .cover {
      .el-image {
        width: 556px;
        height: auto;
      }
    }

    .detail {
      padding-left: 134px;
      text-align: center;
      flex: 1;

      .title {
        font-size: 41px;
        font-weight: 500;
        line-height: 48px;
        padding:32px 0 75px 0;
      }

      .desc {
        font-size: 33px;
        text-align: left;
        font-weight: 400;
        line-height: 38px;
        color: rgba(255, 255, 255, 0.8000);
      }
    }
  }
}
</style>
